export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-human-grade.b40abd96.svg","height":84,"width":74,"blurWidth":0,"blurHeight":0};